import React from 'react';

import './styles.css';

export default props => {
  return (
    <div className="Footer" style={props.style}>
      <a href="#">
        <div className="Footer__logo" />
      </a>
    </div>
  );
};
